export default class DeviceChoice {
	constructor () {
		this.allDevices = window.tbDevices
		this.setupControls()
		this.setupSearch(this.allDevices)
	}

	setupControls () {
		document.querySelectorAll('#deviceForm input').forEach((input) => {
			input.addEventListener('change', this.updateResults.bind(this))
		})

		document.querySelectorAll('.device-choice .search-results a').forEach((a) => {
			a.addEventListener('click', this.onClickDevice.bind(this))
		})
	}

	onClickDevice (e) {
		let clickedElement = e.target
		let i = 0
		while (clickedElement && clickedElement.tagName !== 'A' && i < 4) {
			clickedElement = clickedElement.parentNode
			i += 1
		}

		if (clickedElement.getAttribute('data-type') === 'caps') {
			const htmlString = clickedElement.nextElementSibling.innerHTML.trim()
			document.getElementById('capCode').innerHTML = htmlString
			document.getElementById('flash_notice').style.display = 'block'
			window.scrollTo({ top: 0 })
		}
	}

	updateResults (e) {
		const clickedElement = e.target
		const manufacturers = Array.from(document.querySelectorAll('#deviceForm input[data-category="manufacturer"]:checked')).map((el) => el.getAttribute('data-value'))
		const iosVersions = Array.from(document.querySelectorAll('#deviceForm input[data-category="ios-version"]:checked')).map((el) => el.getAttribute('data-value'))
		const androidVersions = Array.from(document.querySelectorAll('#deviceForm input[data-category="android-version"]:checked')).map((el) => el.getAttribute('data-value'))
		const resolutions = Array.from(document.querySelectorAll('#deviceForm input[data-category="resolution"]:checked')).map((el) => el.getAttribute('data-value'))

		if (manufacturers.length === 0) {
			manufacturers.push('all')
			document.querySelector('#deviceForm ul.manufacturer input[data-value="all"]').checked = true
		}

		if (manufacturers.length > 1 && manufacturers.includes('all') && clickedElement.getAttribute('data-value') !== 'all') {
			document.querySelector('#deviceForm ul.manufacturer input[data-value="all"]').checked = false
			manufacturers.splice(manufacturers.indexOf('all'), 1)
		}

		if (iosVersions.length === 0) {
			iosVersions.push('all')
			document.querySelector('#deviceForm ul.iosVersion input[data-value="all"]').checked = true
		}

		if (iosVersions.length > 1 && iosVersions.includes('all') && clickedElement.getAttribute('data-value') !== 'all') {
			document.querySelector('#deviceForm ul.iosVersion input[data-value="all"]').checked = false
			iosVersions.splice(iosVersions.indexOf('all'), 1)
		}

		if (androidVersions.length === 0) {
			androidVersions.push('all')
			document.querySelector('#deviceForm ul.androidVersion input[data-value="all"]').checked = true
		}

		if (androidVersions.length > 1 && androidVersions.includes('all') && clickedElement.getAttribute('data-value') !== 'all') {
			document.querySelector('#deviceForm ul.androidVersion input[data-value="all"]').checked = false
			androidVersions.splice(androidVersions.indexOf('all'), 1)
		}

		if (resolutions.length === 0) {
			resolutions.push('all')
			document.querySelector('#deviceForm ul.resolution input[data-value="all"]').checked = true
		}

		if (resolutions.length > 1 && resolutions.includes('all') && clickedElement.getAttribute('data-value') !== 'all') {
			document.querySelector('#deviceForm ul.resolution input[data-value="all"]').checked = false
			resolutions.splice(resolutions.indexOf('all'), 1)
		}

		const items = this.allDevices
		let newResults = [...items]

		if (!manufacturers.includes('all')) {
			newResults = newResults.filter((device) => manufacturers.includes(device.platform_name))
		}
		if (!resolutions.includes('all')) {
			newResults = newResults.filter((device) => resolutions.includes(device.resolution))
		}
		if (!androidVersions.includes('all')) {
			newResults = newResults.filter((device) => androidVersions.includes(device.test_environment.version) || device.platform_name !== 'Android')
		}
		if (!iosVersions.includes('all')) {
			newResults = newResults.filter((device) => iosVersions.includes(device.test_environment.version) || device.platform_name !== 'iOS')
		}

		this.renderDevices(newResults)
	}

	setupSearch (devices) {
		const options = {
			shouldSort: true,
			threshold: 0.6,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: ['name']
		}
		const fuse = new Fuse(devices, options)
		const context = this

		document.querySelectorAll('.device-choice .search-device').forEach((input) => {
			input.addEventListener('keyup', function () {
				const term = this.value
				const results = fuse.search(term).map((result) => result.item)
				if (results.length > 0) {
					context.renderDevices(results)
				} else {
					context.renderDevices(context.allDevices)
				}
			})

			input.addEventListener('keydown', function (e) {
				if (e.keyCode === 13) {
					e.preventDefault()
					return false
				}
			})
		})
	}

	renderDevices (devices) {
		const Item = (device) => {
			const classNames = device.available ? 'available' : 'unavailable'
			const sampleApp = device.platform_name === 'Android' ? 'https://testingbot.com/appium/sample.apk' : 'https://testingbot.com/appium/sample.ipa'
			return `<li class="${classNames}">
				<div class="image"><img src="${device.img}" /></div>
				<div class="title">${device.name}</div>
				<div class="spec">Resolution: ${device.resolution}</div>
				<div class="spec">CPU: ${device.cpu}</div>
				<div class="spec">Model: ${device.model_number}</div>
				<a href="#" data-type="caps" style="display: block">Desired Capabilities</a>
				<div class="caps" style="display: none"><pre><code class="java">DesiredCapabilities caps = new DesiredCapabilities();
caps.setCapability("version", "${device.test_environment.version}");
caps.setCapability("app", "${sampleApp}");
caps.setCapability("deviceName", "${device.name}");
caps.setCapability("realDevice", true);
caps.setCapability("platformName", "${device.platform_name}");</code></pre>
				</div>
			</li>`
		}

		document.querySelector('.device-choice .search-results').innerHTML = devices.map(Item).join('')
	}
}
